import { useFormikContext } from 'formik'

import { useEffect } from 'react'

import { KickBackData } from '@/types/unlock'

export function KickBackFormikContext() {
  const { values, setFieldValue } = useFormikContext<Partial<KickBackData>>()
  useEffect(() => {
    if (
      [
        'missing-data',
        'data-mismatch',
        'missing-documentation',
        'expired-documentation',
        'suspicious-data',
      ].includes(values.reason)
    ) {
      setFieldValue('quality_code', 'l1')
    }
    if (['investor-guidelines-breach'].includes(values.reason)) {
      setFieldValue('quality_code', 'l2')
    }
  }, [values.reason])

  return null
}
